import { AssetFolderController } from './asset-folder.controller'

function assetFolder () {
  return {
    restrict: 'E',
    scope: {
      folder: '=',
      cardType: '<',
      selectedAssets: '<',
      visualization: '<',
      currentPage: '<',
      currentSection: '<',
      openPreview: '&',
      modalState: '<',
      shouldDragCards: '<',
      openFolder: '&',
      pricing: '<',
      unbindFolderCampaign: '<',
      selectedFolders: '=',
      onClick: '<',
      disabled: '<'
    },
    templateUrl: '/repository/directives/asset-folder/asset-folder-directive.html?$$REVISION$$',
    controller: AssetFolderController
  }
}

export { assetFolder }
